import React, { forwardRef, useRef } from "react";
import "assets/css/custom.css";

const LoaderForGlobal = () => {
  return (
    <div className="sw_preloader_global">
      <div className="sw_preloader_global">
        <span className="lds-dual-ring-global"></span>
      </div>
    </div>
  );
};

export default LoaderForGlobal;
